import { render, staticRenderFns } from "./top6.vue?vue&type=template&id=28651e89&scoped=true"
import script from "./top6.vue?vue&type=script&lang=js"
export * from "./top6.vue?vue&type=script&lang=js"
import style0 from "./top6.vue?vue&type=style&index=0&id=28651e89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28651e89",
  null
  
)

export default component.exports